import React from "react";
import { Box, Grid2 } from "@mui/material";
import type { Grid2Props } from "@mui/material/Grid2";
import type { BookingScheduleInterface } from "../../Booking-Form/typings/booking.types";
import type { TeamMember } from "../../Booking-Form/typings/team-member";
import {
  dashboard2TopRowColleaguesCellContentSx,
  dashboard2TopRowFlexibleCellSx
} from "../dashboard2-status.styles";
import { dashboard2TopRowStackedCellContentSx } from "../dashboard2.styles";
import { Dashboard2TodayColleaguesStrip } from "./Dashboard2TodayColleaguesStrip";

type Dashboard2TopRowColleaguesCellProps = {
  schedules: BookingScheduleInterface[];
  storedColleagues: TeamMember[];
  isLoading?: boolean;
  onShowColleaguesField?: () => void;
  isWideRow: boolean;
  stackedCellSize: Grid2Props["size"];
};

export const Dashboard2TopRowColleaguesCell: React.FC<Dashboard2TopRowColleaguesCellProps> = ({
  schedules,
  storedColleagues,
  isLoading = false,
  onShowColleaguesField,
  isWideRow,
  stackedCellSize
}) => {
  const cellContentSx = isWideRow
    ? dashboard2TopRowColleaguesCellContentSx
    : dashboard2TopRowStackedCellContentSx;

  return (
    <Grid2
      size={isWideRow ? "auto" : stackedCellSize}
      sx={dashboard2TopRowFlexibleCellSx(isWideRow)}
    >
      <Box sx={cellContentSx}>
        <Dashboard2TodayColleaguesStrip
          schedules={schedules}
          storedColleagues={storedColleagues}
          isLoading={isLoading}
          isWideRow={isWideRow}
          onShowColleaguesField={onShowColleaguesField}
        />
      </Box>
    </Grid2>
  );
};
